var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5618 2.09688C11.3431 2.94066 10.4811 3.44766 9.63722 3.22889C8.79343 3.01012 8.28644 2.14847 8.50483 1.30397C8.72397 0.460436 9.5855 -0.0468105 10.4295 0.171954C11.2735 0.390727 11.7808 1.25297 11.5618 2.09688Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36597 15.2642C7.252 15.703 6.80407 15.9664 6.36516 15.8529C5.92616 15.7389 5.66272 15.2912 5.77646 14.8518C5.89019 14.4127 6.33811 14.1496 6.77715 14.2632C7.21605 14.3767 7.47958 14.825 7.36597 15.2642Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92404 5.48622C2.5658 5.65278 2.95102 6.30813 2.78482 6.94939C2.61863 7.59103 1.96367 7.976 1.322 7.8098C0.680481 7.64361 0.295139 6.98865 0.461591 6.34698C0.627781 5.70583 1.28274 5.32052 1.92404 5.48622Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0919 9.68274C15.3285 9.74388 15.4704 9.98503 15.4089 10.2218C15.3478 10.4581 15.1065 10.5998 14.8702 10.5384C14.634 10.4772 14.4921 10.2358 14.5533 9.99933C14.6148 9.76295 14.8558 9.62147 15.0919 9.68274Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86128 1.34244C8.07566 2.11519 7.62197 2.91592 6.84923 3.1298C6.07614 3.34356 5.27575 2.89037 5.06174 2.11691C4.84786 1.34381 5.30118 0.543797 6.07429 0.329917C6.84717 0.115792 7.64778 0.568957 7.86128 1.34244Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8119 14.8434C10.9141 15.2131 10.6974 15.5958 10.3276 15.6984C9.95769 15.8007 9.57504 15.5841 9.47257 15.214C9.37034 14.8443 9.58703 14.4616 9.95684 14.3594C10.3267 14.257 10.7095 14.4735 10.8119 14.8434Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36583 9.18478C1.93716 9.02629 2.52868 9.36185 2.68678 9.9333C2.8449 10.5049 2.50971 11.0961 1.93838 11.2541C1.36668 11.4126 0.775315 11.0774 0.617189 10.5061C0.459315 9.93402 0.794139 9.34265 1.36583 9.18478Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31402 2.59545C4.83607 3.1088 4.84293 3.94905 4.3293 4.47098C3.81583 4.99328 2.97605 4.99989 2.45365 4.48626C1.9316 3.97291 1.92474 3.13267 2.43861 2.61074C2.95221 2.08831 3.79174 2.08136 4.31402 2.59545Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6195 12.8126C13.8431 13.0326 13.8462 13.3927 13.626 13.616C13.4057 13.8399 13.0458 13.8431 12.8222 13.623C12.5983 13.4026 12.5954 13.0425 12.8157 12.819C13.0359 12.5954 13.3957 12.5926 13.6195 12.8126Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78764 12.6331C3.15463 12.2602 3.75445 12.2551 4.12718 12.6222C4.50003 12.9893 4.50516 13.5886 4.13818 13.9621C3.77144 14.3349 3.17149 14.3401 2.79864 13.9726C2.42567 13.6059 2.42066 13.0059 2.78764 12.6331Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.33b0d23ba5dbb6cf3a69f7ef02fcc624.svg";
export { ForwardRef as ReactComponent };